import React, { useState } from 'react';
import { Box, Typography, IconButton, useMediaQuery, useTheme, Divider } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import plusIcon from '../../../../Assets/images/plus-circle.svg';
import minusIcon from '../../../../Assets/images/minus-circle.svg';
import routes from '../../../../Utils/routes';
import { useStyles } from './styles';

const faqIdeabaaz = [
  {
    question: 'What is Ideabaaz?',
    answer:
      "Ideabaaz is more than a show. It’s a national platform to help Indian founders bring their ideas to life with funding, mentorship, and exposure. If you're building something that solves what India truly needs today, Ideabaaz is where it begins. Idea aapka, paisa humara!",
  },
  // {
  //   question: 'What is Project 47?',
  //   answer:
  //     'Project 47 is a call to India’s most ambitious deep tech founders. Built in the spirit of 1947, it supports IP-led innovation across sectors like climate, space, biotech, and AI. Powered by Turbostart, Project 47 backs technologies that define India’s strategic future.',
  // },
  // {
  //   question: 'What is Dangal?',
  //   points: [
  //     'If you’re building a growth startup that solves real, everyday problems in India: Apply to Ideabaaz.',
  //     'If you’re working on IP-led deep tech with at least an MVP, Project 47 is your path',
  //     'If you have a big idea that’s still in the concept stage, pitch it through Dangal.',
  //   ],
  // },
  {
    question: 'How do I apply?',
    points: [
      <>
        If you're building a growth startup that solves real, everyday problem in India: Apply to{' '}
        <Typography
          component="span"
          // sx={{ cursor: 'pointer', textDecoration: 'underline', fontWeight: '700' }}
          //  onClick={() => window.open(routes.signup)}
        >
          Ideabaaz.
        </Typography>
      </>,
      <>
        If you're working on IP-led deep tech with at least an MVP,
        <Typography
          component="span"
          // sx={{ cursor: 'pointer', textDecoration: 'underline', fontWeight: '700' }}
          //  onClick={() => window.open('https://project47.ideabaaz.co.in')}
        >
          Project 47
        </Typography>
        is your path.
      </>,
      <>
        If you have a big idea that's still in the concept stage, pitch it through{' '}
        <Typography
          component="span"
          // sx={{ cursor: 'pointer', textDecoration: 'underline', fontWeight: '700' }}
          //  onClick={() => window.open('https://www.ideabaazdangal.com/register')}
        >
          Dangal.
        </Typography>
      </>,
    ],
  },
  {
    question: 'Is funding guaranteed?',
    answer: 'All startups will be vetted by our internal selection teams. Funding is determined by investor interest during the pitch, but the platform offers far more than capital.',
  },
  {
    question: 'Who are the investors?',
    answer: 'You’ll meet seasoned investors, operators, and domain experts who understand what it takes to scale in your space. These are serious backers looking for serious founders.',
  },
];

const faqProject47 = [
  {
    question: 'How is Project 47 different from Ideabaaz?',
    answer: 'Project 47 is a focused initiative within Ideabaaz, designed exclusively for deep tech startups developing defensible, forward-looking technologies with real-world impact.',
  },
  {
    question: 'What is ‘Deep Tech’?',
    answer: 'Deep tech refers to innovation rooted in scientific or engineering advances. It includes sectors like:',
    points: [
      '⁠Advanced AI/ML',
      '⁠Robotics & Mechatronics',
      '⁠IoT & Edge Computing',
      '⁠Space Tech',
      '⁠Quantum, Semiconductors & Embedded Systems',
      '⁠Hardware',
      '⁠Climate Tech & Energy',
      ' ⁠BioTech & NeuroTech',
    ],
    extraLine: 'And other IP-led, high-barrier innovations.',
  },
  {
    question: 'Who can apply to Project 47?',
    answer: (
      <>
        Project 47 is exclusively for early-stage Indian Deep Tech startups at the prototype to early revenue stages. If you’re working on non-Deep Tech ventures,&nbsp;
        <Typography
          component="span"
          // sx={{ cursor: 'pointer', textDecoration: 'underline', fontWeight: '700' }} onClick={() => window.open(routes.login)}
        >
          pitch here
        </Typography>
        .
      </>
    ),
  },
  {
    question: 'Is there an application fee ?',
    answer: 'No, applying to Project 47 is completely free. Building the future shouldn’t come with a paywall.',
  },
  {
    question: 'Is Project 47 for software-led tech, or only hardware?',
    answer: 'Yes. We welcome both software- and hardware-led ventures, as long as the core innovation is defensible and grounded in deep tech.',
  },
  {
    question: 'Will all startups be featured on the show?',
    answer: 'Finalists are determined after a rigorous screening process, and select startups will pitch on the show.',
  },
];

const FAQ = () => {
  const classes = useStyles();
  // const [openIndex, setOpenIndex] = useState<number | null>(0);
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const [activeTab, setActiveTab] = useState<'ideabaaz' | 'project47'>('ideabaaz');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xl'));

  const faqData = activeTab === 'ideabaaz' ? faqIdeabaaz : faqProject47;

  const toggleIndex = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <Box className={classes.sectionMob}>
      <Box className={classes.section}>
        <Box className={classes.content}>
          <Box sx={{ display: 'flex', gap: '30px' }}>
            <Typography
              className={classes.heading}
              sx={{ padding: '10px 20px', borderBottom: activeTab === 'ideabaaz' ? '2px solid #E04201' : 'none', cursor: 'pointer' }}
              onClick={() => setActiveTab('ideabaaz')}
            >
              Ideabaaz
            </Typography>
            {/* <Typography
              className={classes.heading}
              sx={{ padding: '10px 20px', borderBottom: activeTab === 'project47' ? '2px solid #E04201' : 'none', cursor: 'pointer' }}
              onClick={() => setActiveTab('project47')}
            >
              Project 47
            </Typography> */}
          </Box>

          {/* FAQ LIST */}
          <Box className={classes.faqList}>
            {faqData.map((item, index) => (
              <Box key={index} className={classes.faqItem}>
                <Box className={classes.questionRow} onClick={() => toggleIndex(index)}>
                  <Typography className={classes.question}>{item.question}</Typography>
                  <IconButton className={classes.iconBtn}>
                    <img src={openIndex === index ? minusIcon : plusIcon} alt={openIndex === index ? 'Collapse' : 'Expand'} className={classes.iconImage} />
                  </IconButton>
                </Box>

                {item.answer && openIndex === index && <Typography className={classes.answer}>{item.answer}</Typography>}

                {item.points &&
                  openIndex === index &&
                  item.points.map((point: any, idx: number) => (
                    <Box key={idx} sx={{ display: 'flex', alignItems: 'start', gap: '1vh', marginTop: '1vh' }}>
                      <FiberManualRecordIcon sx={{ fontSize: '1vh' }} />
                      {typeof point === 'string' ? <Typography>{point}</Typography> : point}
                    </Box>
                  ))}

                {'extraLine' in item && item.extraLine && openIndex === index && <Typography sx={{ marginTop: '1vh', fontStyle: 'italic' }}>{item.extraLine}</Typography>}
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default FAQ;
